'use client'

import { memo } from 'react'

interface SparklineProps {
  data: number[]
  color: string
  width?: number
  height?: number
}

export default memo(function Sparkline({ data, color, width = 80, height = 32 }: SparklineProps) {
  const min = Math.min(...data)
  const max = Math.max(...data)
  const range = max - min || 1

  const points = data
    .map((val, i) => {
      const x = (i / (data.length - 1)) * width
      const y = height - ((val - min) / range) * (height - 4) - 2
      return `${x},${y}`
    })
    .join(' ')

  // Alan dolgusu için path
  const firstX = 0
  const lastX = width
  const areaPath =
    `M${firstX},${height} ` +
    data
      .map((val, i) => {
        const x = (i / (data.length - 1)) * width
        const y = height - ((val - min) / range) * (height - 4) - 2
        return `L${x},${y}`
      })
      .join(' ') +
    ` L${lastX},${height} Z`

  // CSS variable'lar SVG attribute olarak çalışmaz, style olarak kullanılmalı
  const gradId = `grad-${color.replace(/[^a-zA-Z0-9-_]/g, '')}`

  return (
    <svg width={width} height={height} className="shrink-0">
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" style={{ stopColor: color, stopOpacity: 0.3 }} />
          <stop offset="100%" style={{ stopColor: color, stopOpacity: 0.02 }} />
        </linearGradient>
      </defs>
      <path d={areaPath} style={{ fill: `url(#${gradId})` }} />
      <polyline
        points={points}
        fill="none"
        style={{ stroke: color }}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  )
})
